import { atlassianApiGateway } from '@trello/config';

export interface AccountsResponse {
  atlassian: {
    email: string | undefined | null;
  };
  trello: {
    email: string | undefined | null;
    loginId: string | undefined | null;
  };
}

export interface AtlassianAccountResponse {
  email: string;
  name: string;
  avatar: string;
}

export class AtlassianAccountMigrationClient {
  static async fetchAtlassianAccountInfo(): Promise<AtlassianAccountResponse | null> {
    try {
      // eslint-disable-next-line @trello/fetch-includes-client-version
      const response = await fetch(`${atlassianApiGateway}gateway/api/me`, {
        credentials: 'include',
      });
      if (!response.ok) {
        throw new Error(`Invalid response status code: ${response.status}`);
      }
      const data = await response.json();
      return {
        name: data?.name,
        email: data?.email,
        avatar: data?.picture,
      };
    } catch (err) {
      console.error('Failed to fetch Atlassian account', { err });
      return null;
    }
  }
}
